import { Injectable } from '@angular/core';
import { ApiService } from '@services/api.service';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { BillModel, PaymentBillItemPendingModel } from '@data-layer/models/payments';
import { HttpErrorResponse } from '@angular/common/http';
import { enumRespErrors } from '@data-layer/enums/common';
import { enumPaymentProvider } from '@data-layer/enums/payments';
import { isDefined } from '@services/utils/utils.service';

@Injectable({
  providedIn: 'root',
})
export class MarineInsuranceBillsRepository {
  constructor(private apiService: ApiService) {}

  public getBills(
    companyId: number,
    referenceNumbers: string[],
    paymentProvider: enumPaymentProvider,
    paymentCodeId: number,
    isCalculateFee: boolean,
    coupon?: string,
    isShowLoader?: boolean,
    paymentMethodId?: number,
  ): Observable<PaymentBillItemPendingModel> {
    return this.apiService.get<PaymentBillItemPendingModel>(
      `${environment.url.prefixInsurance}v3/companies/${companyId}/pending-bills`,
      {
        params: {
          referenceNumbers,
          isCalculateFee: isCalculateFee,
          ...(isDefined(paymentProvider) && { paymentProvider }),
          ...(isDefined(paymentCodeId) && { paymentCodeId }),
          ...(isDefined(paymentMethodId) && { paymentMethodId }),
          ...(!!coupon && { coupon: coupon }),
        },
      },
      {
        isShowLoader,
      },
    );
  }

  public createBill(
    companyId: number,
    referenceNumbers: string[],
    paymentProvider: enumPaymentProvider,
    paymentCodeId: number,
    billToId: number,
    coupon: string,
    isShowLoader?: boolean,
    paymentMethodId?: number,
  ): Observable<BillModel[]> {
    return this.apiService.post<BillModel[]>(
      `${environment.url.prefixInsurance}v3/companies/${companyId}/bills`,
      {
        referenceNumbers,
        ...(isDefined(paymentProvider) && { paymentProvider }),
        ...(isDefined(paymentCodeId) && { paymentCodeId }),
        ...(isDefined(paymentMethodId) && { paymentMethodId }),
        ...(isDefined(billToId) && { billToId }),
        ...(!!coupon && { coupon }),
      },
      null,
      {
        isShowLoader,
      },
    );
  }

  public getErrorMessage(error: HttpErrorResponse): string {
    if (error?.error) {
      switch (error.error.tag) {
        case enumRespErrors.DiscountUnauthorized:
          return 'DISCOUNT_IS_NOT_AUTHORISED';
        case enumRespErrors.DiscountIsNotActive:
          return 'DISCOUNT_IS_NOT_ACTIVE';
        case enumRespErrors.DiscountCannotBeApplied:
          return 'DISCOUNT_CANNOT_BE_APPLIED';
        case enumRespErrors.DiscountNotFound:
          return 'DISCOUNT_IS_NOT_FOUND';
        default:
          break;
      }
    }
  }
}
